import { ConnectRepositoryError } from "./repository-client.js";

import type { CollectionFileDescriptor } from "@mdbase-dev/connect";
import type { PlannedSourceFileImport, PlannedSourceRepresentation } from "@mdbase-reader/core";

export function sourceFrontmatter(
  plan: PlannedSourceFileImport,
  descriptors: ReadonlyMap<PlannedSourceRepresentation["role"], CollectionFileDescriptor>,
): Readonly<Record<string, unknown>> {
  const capture = plan.capture;
  const metadata = plan.metadata;
  return {
    id: plan.sourceId,
    title: plan.title,
    kind: plan.kind,
    saved_at: plan.savedAt,
    ...(metadata?.authors?.length ? { authors: metadata.authors } : {}),
    ...(metadata?.published ? { published: metadata.published } : {}),
    ...(metadata?.description ? { description: metadata.description } : {}),
    ...(metadata?.language ? { language: metadata.language } : {}),
    ...(metadata?.site ? { site: metadata.site } : {}),
    ...(capture
      ? {
          url: capture.canonicalUrl,
          ...(capture.submittedUrl !== capture.canonicalUrl
            ? { original_url: capture.submittedUrl }
            : {}),
          capture: {
            method: "url",
            application: "dev.mdbase.reader",
            captured_at: capture.retrievedAt,
            submitted_url: capture.submittedUrl,
            canonical_url: capture.canonicalUrl,
          },
        }
      : {}),
    documents: plan.representations.map((representation) => {
      const descriptor = descriptors.get(representation.role);
      if (!descriptor) {
        throw new ConnectRepositoryError(
          "create imported source",
          "missing_file_descriptor",
          `The ${representation.role} representation was not committed.`,
        );
      }
      const derivedFrom = representation.derivedFromRole
        ? descriptors.get(representation.derivedFromRole)
        : undefined;
      return {
        file_id: descriptor.fileId,
        file: `[[${descriptor.path}]]`,
        role: representation.role,
        format: representation.format,
        media_type: representation.mediaType,
        revision: descriptor.contentDigest,
        label: representation.originalName,
        ...(derivedFrom ? { derived_from_file_id: derivedFrom.fileId } : {}),
        ...(capture && representation.role === "archive"
          ? { origin_url: capture.canonicalUrl, retrieved_at: capture.retrievedAt }
          : {}),
      };
    }),
    reading: { status: "inbox" },
  };
}
